/* eslint-disable jsx-a11y/anchor-has-content,jsx-a11y/anchor-is-valid */
import {DialogBoxProps} from "common/DialogBox"
import {RealDevice, SensorStatus} from "dto/realdevice/devices"
import Draggable from "react-draggable"
import {showNotification} from "common/Notification"
import {useEffect, useState} from "react"
import {useImageResource} from "hooks/queries/image-resource-query"
import {useRootStore} from "store/useRootStore"
import {observer} from "mobx-react"
import {SensorStatusTag, StatusTag} from "pages/dashboard/wheelchair/WheelchairListItems"
import {NoneOperationCommentView} from "pages/dashboard/popup/noneOperation/NoneOperationCommentView"
import dayjs from "dayjs";

interface RealDeviceInfoWindowProps extends DialogBoxProps {
    device?: RealDevice,
}

export const RealDeviceInfoWindow = ({show, close, device}: RealDeviceInfoWindowProps) => {
    if (!show || !device) return null
    return <RealDeviceInfoWindowBody show={show} device={device} close={close}/>
}

const RealDeviceInfoWindowBody = ({close, device}: RealDeviceInfoWindowProps) => {
    const [index, setIndex] = useState<number>(0)
    if (!device) {
        showNotification("선택된 디바이스가 없어서 정보를 표시 할 수 없습니다.")
        return null
    }
    return (
        <Draggable handle="#device-info-window">
            <div className="pop-content">
                <a className="delete-btn" onClick={close}/>
                <div className="topbody" id="device-info-window">
                    <div className="columns">
                        {index === 0 && <DeviceInfoHeader device={device}/>}
                        {index === 1 && <UserInfoHeader device={device}/>}
                        {index === 2 && <CommentHeader device={device}/>}
                        <div className="column">
                            <div className="tabs is-boxed2 is-right">
                                <ul>
                                    <li className={index === 0 ? "is-active" : ""} onClick={() => setIndex(0)}>
                                        <a><span>단말기 정보</span></a>
                                    </li>
                                    <li className={index === 1 ? "is-active" : ""} onClick={() => setIndex(1)}>
                                        <a><span>사용자 정보</span></a>
                                    </li>
                                    <li className={index === 2 ? "is-active" : ""} onClick={() => setIndex(2)}>
                                        <a><span>미운행 사유</span></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="is-gapless mainbody" style={{overflowY: "auto", overflowX: 'hidden'}}>
                    {index === 0 && <DeviceInfo device={device}/>}
                    {index === 1 && <UserInfo device={device}/>}
                    {index === 2 && <NoneOperationCommentView device={device}/>}
                </div>
            </div>
        </Draggable>
    )
}

const DeviceInfoHeader = ({device}: { device: RealDevice }) => {
    return (
        <div className="column is-clickable is-fullwidth">
            <div className="mt5">
                <p className="is-size-6">휠체어(단말기) ID</p>
                <p className="is-size-3">{device.communicationDevice.eui}</p>
            </div>
        </div>
    )
}

const UserInfoHeader = ({device}: { device: RealDevice }) => {
    return (
        <div className="column is-clickable is-fullwidth">
            <div className="mt5">
                <p className="is-size-6">전동보장구(휠체어) 사용자 정보</p>
                <p className="is-size-3" style={{wordWrap: "break-word"}}>{device.name}</p>
            </div>
        </div>
    )
}

const CommentHeader = ({device}: { device: RealDevice }) => {
    return (
        <div className="column is-clickable is-fullwidth">
            <div className="mt5">
                <p className="is-size-6">전동보장구(휠체어) 미운행 사유</p>
                <p className="is-size-3" style={{wordWrap: "break-word"}}>{device.name}</p>
            </div>
        </div>
    )
}

const DeviceInfo = observer(({device}: { device: RealDevice }) => {
    const {
        dashboardStore: {
            setShowPathTrackingInfo,
            setShowImpactHistory
        }
    } = useRootStore()
    const [address, setAddress] = useState("")
    const deviceStatus = device.communicationDevice.status || "STAND_BY";
    const sensorStatus = device.communicationDevice.sensorStatus || {} as SensorStatus
    useEffect(() => {
        const geocoder = new kakao.maps.services.Geocoder()
        const currentLatLng = device.communicationDevice.currentLatLng
        if (!currentLatLng || !currentLatLng.lng || !currentLatLng.lat) return
        geocoder.coord2Address(parseFloat(currentLatLng.lng), parseFloat(currentLatLng.lat), (result, status) => {
            if (status === kakao.maps.services.Status.OK) {
                if (!result || result.length == 0) return
                const address = result[0].address
                if (!address) return
                setAddress(address.address_name)
            } else {
                setAddress("현재 위/경도에 해당 하는 주소가 없습니다")
            }
            console.log("result : ", result)
        })
    }, [device.communicationDevice.currentLatLng])
    const installationDate = device?.installationDate  ? dayjs(device.installationDate).format("YYYY년 MM월 DD일") : '-'
    return (
        <>
            <div className="columns  is-gapless mt-3 mb0">
                <div style={{marginLeft: 'auto'}}/>
                <SensorStatusTag sensorStatus={sensorStatus}/>
                <div style={{marginRight: 7}}/>
            </div>
            <div className="columns mt-0">
                <div className="column">
                    <div className="ml20">
                        <p className="is-size-6 has-text-link">사용자 이름</p>
                        <p className="is-size-4">{device.name}</p>
                    </div>
                </div>
                <div className="column">
                    <div className="ml20">
                        <p className="is-size-6 has-text-link">현재상태</p>
                        <p className="is-size-4">
                            <StatusTag stat={deviceStatus} sensorStatus={sensorStatus}/>
                            {/*<span className={`tag is-size-6 ${DeviceStatusTagClassName[deviceStatus]}`}>*/}
                            {/*    {DeviceStatusValue[deviceStatus]}*/}
                            {/*</span>*/}
                        </p>
                    </div>
                </div>
                <div className="column">
                    <div className="ml20">
                        <p className="is-size-6 has-text-link">보조 배터리 상태</p>
                        <p className="is-size-4">
                            {`${device.battery?.level || 0} %`}
                        </p>
                    </div>
                </div>
            </div>
            <div className="columns">
                <div className="ml20 column">
                    <p className="is-size-6 has-text-link">현재위치(위/경도)</p>
                    <p className="is-size-5 level">
                        <div className="level-left">
                            <div className="level-item">
                            <span
                                className="tag is-primary mt"> 위도 </span>
                            </div>
                            <div className="level-item">
                                <span>{device.communicationDevice.currentLatLng?.lat || "-"}</span>
                            </div>

                            <div className="level-item">
                            <span
                                className="tag is-primary ml-6">경도</span>
                            </div>
                            <div className="level-item">
                                {device.communicationDevice.currentLatLng?.lng || "-"}
                            </div>
                        </div>

                    </p>
                </div>
                <div className="ml-6 column">
                    <p className="is-size-6 has-text-link">설치일</p>
                    <p className="is-size-5">{installationDate}</p>
                </div>
            </div>
            <div className="mt30 ml20">
                <p className="is-size-6 has-text-link">현재 위치(주소)</p>
                <p className="is-size-5">
                    {address}
                </p>
            </div>
            <div className="mt50 ml20">
                <span className="button is-info" onClick={() => setShowPathTrackingInfo(true)}>경로추적</span>
                <span className="button is-info ml-2" onClick={() => setShowImpactHistory(true)}>넘어짐 감지</span>
            </div>
        </>
    )
})

const UserInfo = ({device}: { device: RealDevice }) => {
    // const deviceStatus = device.communicationDevice.status || "STAND_BY";
    console.log("images : ", device.imageFiles)
    return (
        <>
            <div className="columns  ">
                <div className="column">
                    <div className="mt30 ml20">
                        <p className="is-size-6 has-text-link">사용자 이름</p>
                        <p className="is-size-4">{device.name}</p>
                    </div>

                </div>
                <div className="column">
                    <div className="mt30 ml20">
                        <p className="is-size-6 has-text-link">연락처</p>
                        <p className="is-size-5">{device.mobile?.phoneNumber}</p>
                    </div>
                </div>
            </div>
            <div className="columns  ">
                <div className="column">
                    <div className="ml20">
                        <p className="is-size-6 has-text-link">보호자 이름</p>
                        <p className="is-size-4">{device.protector?.name}</p>
                    </div>

                </div>
                <div className="column">
                    <div className="ml20">
                        <p className="is-size-6 has-text-link">보호자 연락처</p>
                        <p className="is-size-5">{device.protector?.mobile}</p>
                    </div>
                </div>
            </div>
            <div className="mt10 ml20">
                <p className="is-size-6 has-text-link">주소</p>
                <p className="is-size-5">{device.address.address} {device.address.subAddress}</p>
            </div>
            <div className="mt10 ml20">
                <p className="is-size-6 has-text-link">사진정보</p>
                <p className="is-size-5 columns ml-1" style={{width: 475, height: 180, overflow: "auto"}}>
                    {device.imageFiles?.map((id, idx) => {
                        return (
                            <DeviceImage key={idx} id={id}/>
                        )
                    })}
                </p>
            </div>
        </>
    )
}

const DeviceImage = ({id,}: { id: number | string }) => {
    const {data: imageResource} = useImageResource(id.toString())
    const [show, setShow] = useState<boolean>(false)
    if (!imageResource) return null
    const imageUrl = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_FILE_RESOURCE_URL}${imageResource.fileName}`

    return (
        <div className="image mr-3 mb-3 column" style={{width: 150, minWidth: 150, maxWidth: 150}}
             title="원본 크기로 보려면 클릭하세요">
            <img src={imageUrl} alt="장비사진" style={{borderRadius: 8, cursor: "pointer"}}
                 onClick={(e) => {
                     e.preventDefault()
                     e.isPropagationStopped()
                     setShow(true)
                 }}/>
            {show &&
                <LargeImage url={imageUrl} close={() => setShow(false)}/>
            }
        </div>
    )
}

const LargeImage = ({url, close}: { url: string, close: () => void }) => {
    return (
        <Draggable handle="#large-image-viewer">
            <div className="modal is-active" style={{width: 600, height: 550, zIndex: 10000, left: -620, top: 250}}>
                {/*<div className="modal-background" onClick={close}/>*/}
                <div className="modal-card" style={{maxHeight: 800}}>
                    <header className="modal-card-head has-background-link" id="large-image-viewer">
                        <p className="modal-card-title has-text-white">사진 보기</p>
                        <a className="delete" aria-label="close" onClick={close}/>
                    </header>
                    <section className="modal-card-body">
                        <img src={url} alt="장비사진" style={{maxWidth: 560, maxHeight: 520}}/>
                    </section>
                    <footer className="modal-card-foot">
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a className="button" onClick={close}>닫기</a>
                    </footer>
                </div>
            </div>
        </Draggable>
    )
}





